module.exports = __webpack_public_path__ + "assets/img/show.027eb907.svg";